import { render, staticRenderFns } from "./BroadOpenAnswer.vue?vue&type=template&id=a8bef8e2&scoped=true&"
import script from "./BroadOpenAnswer.vue?vue&type=script&lang=js&"
export * from "./BroadOpenAnswer.vue?vue&type=script&lang=js&"
import style0 from "./BroadOpenAnswer.vue?vue&type=style&index=0&id=a8bef8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bef8e2",
  null
  
)

export default component.exports